import { useMutation, useQueryClient } from '@tanstack/react-query';
import z from 'zod';
import {
  StatusCode,
  postApiV2CustomersCustomerIdPayment,
} from '@hungryroot/rest';
import { invalidateAccountSettings } from './useGetAccountSettings';

export const CustomerPaymentSchema = z.object({
  stripe_token: z.string({
    required_error: 'Please enter a valid card number.',
  }),
});

export type CustomerPaymentSchema = z.infer<typeof CustomerPaymentSchema>;

export function useUpdatePaymentMethod() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: CustomerPaymentSchema) => {
      const resp = await postApiV2CustomersCustomerIdPayment(payload);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    onSuccess() {
      invalidateAccountSettings(queryClient);
    },
  });
}
